import moment from 'moment';
import 'moment/locale/ru';

export const formatToSimpleView = (date: string) => {
  const capitalize = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

  return capitalize(moment(date, 'DD.MM.YYYY, hh:mm:ss').format('DD.MM.YYYY'));
};
